<template>
  <section class="mt-4 mb-6">
    <h2
      v-if="showTitle"
      class="text-EXPONDO-black text-xl mb-4 lg:text-3xl"
    >
      {{ title }}
    </h2>
    <div
      class="grid w-full auto-rows-fr grid-cols-2 gap-x-4 gap-y-4"
      :class="{'lg:grid-cols-4': displayPosts.length > 2}"
    >
      <div
        v-for="(post, index) in displayPosts"
        :key="index"
        :class="{'col-span-2': index === 0 && displayPosts.length === 3}"
      >
        <BlogCard :post="post" />
      </div>
    </div>
  </section>
</template>
<script lang="ts">
import BlogCard from '~/components/molecules/Blog/BlogCard.vue';
import type { BlogCardItem } from '~~/types/blog/BlogCardItem';
export default defineComponent({
  name: 'BlogPosts',
  components: {
    BlogCard,
  },
  props: {
    posts: {
      type: Array as PropType<BlogCardItem[]>,
      default: () => [],
      validator: (posts: BlogCardItem[]) => {

        return posts.every((post) => {

          return post.author && post.createdAt && post.excerpt && post.postLink && post.thumbnail && post.title;
        
        });
      
      },
    },
    title: {
      type: String,
      required: true,
    },
    showTitle: {
      type: Boolean,
      default: true,
    },
  },
  setup(props) {

    const displayPosts = props.posts.slice(0, 4);

    return {
      displayPosts,
    };
  
  },
});
</script>
